var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUmbrella(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-ca_rd",
    "data-name": "icon-ca rd",
    transform: "translate(-240 -3397)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 80,
    height: 80,
    transform: "translate(240 3397)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-umbrella",
    transform: "translate(260.273 3417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67432",
    "data-name": "Group 67432",
    transform: "translate(-0.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67431",
    "data-name": "Group 67431",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80492",
    "data-name": "Path 80492",
    d: "M39.269,15.915A21.39,21.39,0,0,0,21.407,3.405V1.667a1.667,1.667,0,0,0-3.333,0V3.4A21.4,21.4,0,0,0,.186,15.915a6.575,6.575,0,0,0,.675,6.137A6.692,6.692,0,0,0,6.407,25H18.074V35a1.667,1.667,0,0,1-3.333,0,1.667,1.667,0,1,0-3.333,0,5,5,0,1,0,10,0V25H33.046a6.7,6.7,0,0,0,5.548-2.948,6.58,6.58,0,0,0,.675-6.137Zm-3.435,4.268a3.322,3.322,0,0,1-2.788,1.483H6.407a3.32,3.32,0,0,1-2.788-1.485,3.212,3.212,0,0,1-.333-3.03C5.709,11.077,12.631,6.667,19.741,6.667A18.015,18.015,0,0,1,36.172,17.152a3.205,3.205,0,0,1-.338,3.032Z",
    transform: "translate(0.281)",
    fill: "#12784a"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.002c3f07d575e271d65c0b3f61f422cc.svg";
export { ForwardRef as ReactComponent };